<template>
  <transition name="modal-outer">
    <section
      v-if="open"
      @click="close"
      @keyup.esc="close"
      class="absolute bg-white/95 dark:bg-slate-900/95 flex flex-col top-0 left-0 h-full min-h-screen w-screen overflow-x-hidden overflow-y-auto z-20"
    >
      <section @click.stop class="flex flex-col">
        <div class="flex flex-row p-2">
          <div class="w-full opacity-50 text-center">
            aperte esc para fechar
          </div>
          <rpm-button
            icon="fa-solid fa-xmark"
            color-class="rounded-full hover:bg-black/20 dark:hover:bg-white/20 text-default dark:text-white py-2 px-2.5"
            @click="close"
          ></rpm-button>
        </div>
        <input
          ref="search"
          class="bg-transparent text-6xl font-semibold outline-none py-6 px-10"
          placeholder="Solicitações, serviços, pessoas..."
          v-model="search"
          type="text"
        >
        <section class="grid auto-cols-fr grid-flow-col gap-4 px-10 pb-4">
          <template v-if="!loading">
            <search-list @close="close" title="Solicitações" :list="suggestions.services" v-slot="{item}" class="flex flex-col gap-0.5">
              <badge class="bg-theme text-white">
                {{item.id}}
              </badge>
              <span class="uppercase font-bold">
                {{item.source_service_name}}
              </span>
              <span v-if="item.person" class="text-sm capitalize">
                {{item.person.name}}
              </span>
              <span class="text-xs">
                {{ formatDate(item.started_at, 'DD/MM/YYYY HH:mm') }}
              </span>
            </search-list>
            <search-list @close="close" title="Serviços" :list="suggestions.source_services" v-slot="{item}" class="flex flex-col gap-0.5">
              <span class="font-semibold">
                {{item.name}}
              </span>
              <rpm-read-more class="text-sm" :text="item.description" />
            </search-list>
            <search-list @close="close" title="Pessoas" :list="suggestions.people" v-slot="{item}" class="flex flex-col gap-0.5">
              <badge class="bg-theme text-white">
                {{item.id}}
              </badge>
              <span class="capitalize">
                {{item.name}}
              </span>
              <span v-if="item.cpf_cnpj" class="text-sm">
                CPF/CNPJ: <b>{{item.cpf_cnpj}}</b>
              </span>
            </search-list>
          </template>
          <section v-else class="flex flex-row justify-center">
            <rpm-spinner
              v-if="loading"
              size="h-20 w-20"
              border="border-8"
            ></rpm-spinner>
          </section>
        </section>
      </section>
    </section>
  </transition>
</template>


<script>

import SearchList from './searchList';

import RpmReadMore from "#components/RpmReadMore";
import RpmSpinner from "#components/RpmSpinner.vue";
import Badge from "#components/Badge.vue";

import siteSearchRepository from '#repositories/siteSearchRepository';

import {formatDate} from "#functions/formatter.js";

export default {
  name: "HomeSearch",
  components: {
    SearchList,
    RpmReadMore,
    RpmSpinner,
    Badge
  },
  data() {
    return {
      loading: false,
      searchTimer: null,
      suggestions: {},
      search: ''
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate(...params){
      return formatDate(...params);
    },
    close(){
      this.search = '';
      this.suggestions = {};
      this.$emit('close');
    }
  },
  watch:{
    open(bool){
      if(bool) this.$nextTick(() => {
        this.$refs.search.focus();
      });
    },
    search(query){
      if(query.length >= 4){
        clearTimeout(this.searchTimer);
  
        this.searchTimer = setTimeout(async () => {
          this.loading = true;
          query = query.replace(/[\/\(\)\.\,]/g, '');
          this.suggestions = (await siteSearchRepository.search(query)).data;
          this.loading = false;
        }, 750);
      }
    }
  }
};
</script>

<style scoped>
.modal-outer-enter-active,
.modal-outer-leave-active {
  transition: opacity 0.15s ease-out;
}

.modal-outer-enter-from,
.modal-outer-leave-to {
  opacity: 0;
}
</style>
